<template>
  <div class="medication-settings m-4">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <h5 class="mb-0">Medications</h5>
      <b-button
        class="pt-2 pb-2"
        size="sm"
        variant="primary"
        @click="addMedication"
        >New</b-button
      >
    </div>
    <div class="d-flex flex-row justify-content-end align-items-center mb-3">
      <b-form-group class="text-left mb-0">
        <b-form-input
          size="sm"
          placeholder="Search"
          v-model="search"
        ></b-form-input>
      </b-form-group>
    </div>
    <grid
      :groupFeature="false"
      :columns="columns"
      :autoHeight="true"
      :data="list"
      :columnLines="false"
      :searchFeature="true"
      :stripeFeature="false"
    />
    <bottom-paginator
      :total="total"
      :page="paginator.page"
      :perPage="paginator.perPage"
      @change-page="changePage"
    />
    <b-modal
      centered
      ref="form-modal"
      :title="(form.id ? 'Edit ' : 'Add ') + 'medication'"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="submitMedication"
      no-close-on-backdrop
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <b-form-group label="Name">
        <b-form-input v-model="form.name" maxLength="100"></b-form-input>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import medicationServer from "../../server/medication";
import Grid from "../../third_party/grid/Grid.vue";
import BottomPaginator from "../controls/BottomPaginator.vue";

export default {
  name: "MedicationCrud",
  components: {
    Grid,
    BottomPaginator
  },
  data() {
    return {
      list: [],
      form: {
        id: null,
        name: ""
      },
      gridConfig: {
        minHeight: "20em",
        columnLines: false
      },
      search: "",
      total: 0,
      paginator: {
        page: 0,
        perPage: 10
      }
    };
  },
  mounted() {
    this.getMedications();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    searchMedication(delayed = true) {
      if (delayed) {
        if (this.lastTimeout) {
          clearTimeout(this.lastTimeout);
          this.lastTimeout = null;
        }
        this.lastTimeout = setTimeout(async () => {
          this.getMedications();
        }, 1000);
      } else {
        this.getMedications();
      }
    },
    getMedications() {
      const filter = {
        searchPhrase: this.search,
        page: this.paginator.page,
        pageSize: this.paginator.perPage,
        orderBy: "name"
      };

      medicationServer.query(filter).then(result => {
        this.list = result;
      });

      medicationServer.searchCount(filter).then(count => {
        this.total = count;
      });
    },
    addMedication() {
      this.form = {
        id: null,
        name: ""
      };
      this.$refs["form-modal"].show();
    },
    editMedication(medication) {
      this.form = {
        id: medication.id,
        name: medication.name
      };
      this.$refs["form-modal"].show();
    },
    async submitMedication() {
      const medication = { name: this.form.name };
      if (this.form.id) {
        await medicationServer.update(this.form.id, medication);
      } else {
        await medicationServer.create(medication);
      }

      this.$refs["form-modal"].hide();
      this.showAlertSuccess();
      this.getMedications();
    },
    deleteMedication(id) {
      this.$dialog
        .confirm(
          { title: "Are you sure you want to delete this record?" },
          { view: "confirm-delete" }
        )
        .then(async () => {
          await medicationServer.delete(id);
          this.getMedications();
        })
        .catch(() => {});
    },
    changePage(page) {
      this.paginator.page = page;
      this.getMedications();
    }
  },
  computed: {
    columns() {
      return [
        {
          text: "Name",
          field: "name",
          width: "90%",
          sortable: false
        },
        {
          text: "",
          type: "action",
          cellCls: "pointer-cell",
          field: "action",
          width: "10%",
          align: "right",
          actions: [
            {
              tooltip: "Edit",
              renderer: () => {
                return `<img class="b-action-item" src="${
                  this.isStandalone()
                    ? `/icons/edit.svg`
                    : `/desktop/icons/edit.svg`
                }">`;
              },
              onClick: ({ record }) => {
                this.editMedication(record);
              }
            },
            {
              tooltip: "Delete",
              renderer: () => {
                return `<img class="b-action-item ml-2 mr-1" src=	"${
                  this.isStandalone()
                    ? `/icons/delete.svg`
                    : `/desktop/icons/delete.svg`
                }">`;
              },
              onClick: ({ record }) => {
                this.deleteMedication(record.id);
              }
            }
          ]
        }
      ];
    }
  },
  watch: {
    search: function() {
      this.paginator.page = 0;
      this.searchMedication();
    }
  }
};
</script>

<style>
.medication-settings .b-grid-container .b-container {
  max-height: calc(100vh - 364px);
}
</style>
